export const sanitizePost = (text = "") => {
    return text
        .replace(/\n[ \t]+/g, "\n")
        // 2. remove leading spaces on the first line
        .replace(/^\s+/, "")
        // 3. remove trailing spaces on every line (your emoji issue)
        .replace(/[ \t]+$/gm, "");
};
